export default __webpack_public_path__ + "static/media/Walker's Straps of the Seven Suns.d98d70a7.jpg";